import authService from "./authService";

const CC_CACHE_KEY = "cached_content_creators";

interface ContentCreator {
  user_id: string;
  user_name: string;
}

/**
 * Fetches content creators with session caching
 * Checks sessionStorage first, only calls API if cache is missing
 * @returns Promise<ContentCreator[]> Array of content creators
 */
export const fetchContentCreatorsWithCache = async (): Promise<ContentCreator[]> => {
  try {
    // Check sessionStorage for cached data
    const cachedData = sessionStorage.getItem(CC_CACHE_KEY);
    
    if (cachedData) {
      try {
        const parsed = JSON.parse(cachedData);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed;
        }
      } catch (e) {
        // If parsing fails, clear cache and fetch fresh data
        sessionStorage.removeItem(CC_CACHE_KEY);
      }
    }
    
    // Fetch from API
    const response = await authService.get("admin/list/cc");
    if (response.data && response.data.cc && Array.isArray(response.data.cc)) {
      const ccList = response.data.cc;
      
      // Cache the result
      sessionStorage.setItem(CC_CACHE_KEY, JSON.stringify(ccList));
      
      return ccList;
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching content creators:', error);
    // Try to return cached data even if API fails
    const cachedData = sessionStorage.getItem(CC_CACHE_KEY);
    if (cachedData) {
      try {
        const parsed = JSON.parse(cachedData);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch (e) {
        // Ignore parse errors
      }
    }
    return [];
  }
};